import { ShipCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  ship?: ShipCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const Ship = ({ isDisabled, ship, onChange, t }: Props) => {
  const { shipName } = ship || { shipName: '' };

  return (
    <DetailsInput
      name="shipName"
      label={t('entry.ship.name')}
      isDisabled={isDisabled}
      value={shipName}
      onChange={onChange}
    />
  );
};

export default withTranslation()(Ship);
